import { SelfreflectionQuestion, SelfreflectionQuestionBoolean, SelfReflectionQuestionType } from '../../../types'

export const oneSelfreflectionValueExists = (
  selfreflectionQuestions: (Pick<SelfreflectionQuestion, 'type' | 'comment' | 'value'> & {
    subItems: Pick<SelfreflectionQuestionBoolean, 'value'>[]
  })[],
): boolean => {
  return selfreflectionQuestions
    .map(q => {
      if (q.type === SelfReflectionQuestionType.BooleanCheckbox) {
        return q.comment || q.subItems.some(item => item.value)
      } else {
        return q.value || q.comment
      }
    })
    .some(value => !!value)
}
